module.exports = __webpack_public_path__ + "static/img/空值@2x.6cc1cfa8.png";